import { createFileRoute } from '@tanstack/react-router';
import { Suspense, lazy } from 'react';
import { PageLoader } from '@/components/shared/PageLoader';

const SinglePostPage = lazy(() =>
  import('@/components/community/SinglePostPage').then((m) => ({ default: m.SinglePostPage })),
);

export const Route = createFileRoute('/community/post/$postId')({
  component: () => (
    <Suspense fallback={<PageLoader />}>
      <SinglePostPage />
    </Suspense>
  ),
});
